import "./index.css";
import AppRoutes from "./Routes";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { captureHandledError } from "@/lib/sentry";
import { isDevAuthBypass } from "@/lib/devAuth"; // prototype-only
import { PrototypeDevBar } from "@/prototypes/multi-statement-settlement/PrototypeDevBar"; // prototype-only

// Create a client
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureHandledError(error, {
        tags: {
          source: "react-query",
          type: "query",
        },
        extra: {
          queryHash: query.queryHash,
          queryKey: query.queryKey,
        },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      captureHandledError(error, {
        tags: {
          source: "react-query",
          type: "mutation",
        },
        extra: {
          mutationKey: mutation.options.mutationKey,
        },
      });
    },
  }),
});

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
          {isDevAuthBypass() && <PrototypeDevBar />}
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
